<template>
    <div class="topnav" v-if="routelist && routelist.length > 1">
        <div class="menu">
            <router-link v-if="item.right" v-for="item in routelist" :key="item.route" class="link"
                :to="{ name: item.route }">{{ item.name }}
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    props: ['routelist']
}
</script>
<style scoped lang="scss">
.topnav {
    box-shadow: 0 3px 6px rgba(73, 80, 96, 0.1);
    height: 54px;
    line-height: 54px;
    background: #fff;
    z-index: 5;

    .menu {
        position: relative;
        text-align: center;
        height: 100%;
        white-space: nowrap;
    }

    .link {
        position: relative;
        font-size: 14px;
        line-height: 1.2;
        margin: 0 30px;
        color: #495060;
        height: 45%;
        cursor: pointer;
        display: inline-block;
        text-decoration: none;
    }

    .link.router-link-active {
        background-color: #e8f0f9;
        color: #3a6ea5;
        border-radius: 10px;
    }
}
</style>